module.exports = __webpack_public_path__ + "img/VERI.2a62724f.svg";